var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalkonSmsTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 249.466,
    height: 49.119,
    viewBox: "0 0 249.466 49.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Falkon_sms_logo",
    "data-name": "Falkon sms logo",
    transform: "translate(23.124 -0.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1782.7,644.646V628h9.987v1.786h-7.967v5.625h7.215V637.2h-7.215v7.443Z",
    transform: "translate(-1713.15 -611.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1971.512,644.646H1969.4L1975.509,628h2.087l6.109,16.646h-2.113l-4.978-14.017h-.131Zm.778-6.5h8.523v1.785h-8.523Z",
    transform: "translate(-1887.639 -611.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2262.9,644.646V628h2.015v14.86h7.738v1.786Z",
    transform: "translate(-2161.941 -611.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M2494.8,644.646V628h2.015v8.261h.2l7.477-8.261h2.635l-6.992,7.509,6.992,9.137h-2.439l-5.788-7.738-2.08,2.341v5.4Z",
    transform: "translate(-2378.673 -611.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M2750.8,633.049a10.161,10.161,0,0,1-.949,4.553,7.149,7.149,0,0,1-2.609,2.963,7.427,7.427,0,0,1-7.58,0,7.133,7.133,0,0,1-2.61-2.963,11.4,11.4,0,0,1,0-9.1,7.116,7.116,0,0,1,2.61-2.956,7.428,7.428,0,0,1,7.58,0,7.15,7.15,0,0,1,2.609,2.956A10.123,10.123,0,0,1,2750.8,633.049Zm-1.949,0a8.354,8.354,0,0,0-.719-3.649,5.12,5.12,0,0,0-9.36,0,9.639,9.639,0,0,0,0,7.306,5.12,5.12,0,0,0,7.417,2.25,5.348,5.348,0,0,0,1.943-2.25A8.218,8.218,0,0,0,2748.849,633.049Z",
    transform: "translate(-2604.191 -608.164)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M3060.7,628v16.646h-1.95l-9.071-13.068h-.165v13.068H3047.5V628h1.95l9.1,13.1h.165V628Z",
    transform: "translate(-2895.223 -611.435)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M3431.763,637.517a2.063,2.063,0,0,0-.837-1.531,3.3,3.3,0,0,0-2.008-.543,3.817,3.817,0,0,0-1.453.242,2.037,2.037,0,0,0-.909.661,1.562,1.562,0,0,0-.313.955,1.4,1.4,0,0,0,.2.785,1.819,1.819,0,0,0,.57.569,4.136,4.136,0,0,0,.85.419,7.537,7.537,0,0,0,1.019.294l1.5.36a10.948,10.948,0,0,1,2,.648,6.368,6.368,0,0,1,1.576,1,4.262,4.262,0,0,1,1.034,1.4,4.439,4.439,0,0,1,.378,1.845,4.579,4.579,0,0,1-.777,2.649,4.947,4.947,0,0,1-2.212,1.727,8.916,8.916,0,0,1-3.474.615,9.079,9.079,0,0,1-3.5-.615,5.128,5.128,0,0,1-2.329-1.838,5.429,5.429,0,0,1-.871-3.009h3.4a2.431,2.431,0,0,0,1.628,2.231,4.445,4.445,0,0,0,1.636.281,4.2,4.2,0,0,0,1.556-.262,2.371,2.371,0,0,0,1.027-.719,1.7,1.7,0,0,0,.367-1.066,1.419,1.419,0,0,0-.327-.942,2.681,2.681,0,0,0-.962-.654,9.817,9.817,0,0,0-1.544-.484l-1.811-.458a7.6,7.6,0,0,1-3.324-1.6,3.717,3.717,0,0,1-1.211-2.93,4.357,4.357,0,0,1,.805-2.642,5.377,5.377,0,0,1,2.25-1.766,8.007,8.007,0,0,1,3.251-.635,7.735,7.735,0,0,1,3.238.635,5.1,5.1,0,0,1,2.159,1.766,4.7,4.7,0,0,1,.8,2.616Z",
    transform: "translate(-3245.415 -615.641)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M3663,636h4.344l4.583,11.185h.2L3676.709,636h4.343v16.646h-3.414V641.808h-.145l-4.3,10.759h-2.329l-4.3-10.8h-.144v10.877H3663Z",
    transform: "translate(-3470.466 -618.911)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M3988.068,637.517a2.08,2.08,0,0,0-.836-1.531,3.3,3.3,0,0,0-2.01-.543,3.844,3.844,0,0,0-1.457.242,2.045,2.045,0,0,0-.9.661,1.556,1.556,0,0,0-.312.955,1.338,1.338,0,0,0,.188.785,1.841,1.841,0,0,0,.577.569,3.876,3.876,0,0,0,.843.419,7.482,7.482,0,0,0,1.026.294l1.491.36a10.827,10.827,0,0,1,2,.648,6.218,6.218,0,0,1,1.578,1,4.294,4.294,0,0,1,1.041,1.4,4.546,4.546,0,0,1,.377,1.845,4.634,4.634,0,0,1-.777,2.649,4.915,4.915,0,0,1-2.212,1.727,8.924,8.924,0,0,1-3.479.615A9.063,9.063,0,0,1,3981.7,649a5.114,5.114,0,0,1-2.322-1.838,5.417,5.417,0,0,1-.875-3.009h3.406a2.51,2.51,0,0,0,.485,1.393,2.542,2.542,0,0,0,1.144.837,4.381,4.381,0,0,0,1.628.281,4.176,4.176,0,0,0,1.557-.262,2.418,2.418,0,0,0,1.027-.719,1.658,1.658,0,0,0,.366-1.066,1.379,1.379,0,0,0-.326-.942,2.607,2.607,0,0,0-.963-.654,9.753,9.753,0,0,0-1.536-.484l-1.812-.458a7.632,7.632,0,0,1-3.329-1.6,3.689,3.689,0,0,1-1.208-2.93,4.328,4.328,0,0,1,.811-2.642,5.384,5.384,0,0,1,2.243-1.766,8.02,8.02,0,0,1,3.257-.635,7.725,7.725,0,0,1,3.238.635,5.121,5.121,0,0,1,2.158,1.766,4.676,4.676,0,0,1,.8,2.616Z",
    transform: "translate(-3765.33 -615.641)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 12.796,
    height: 4.799,
    rx: 2.4,
    transform: "translate(-16.571 30.997)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 12.796,
    height: 4.799,
    rx: 2.4,
    transform: "translate(-16.579 4.387)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 12.796,
    height: 4.799,
    rx: 2.4,
    transform: "translate(-23.124 17.607)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1179.244,386.69c-6.121-1.624-9.88,1.423-15.744,2.619l10.312,10.312a4.936,4.936,0,0,1,1.375,2.458c.065-.214.131-.41.192-.589,4.187-11.8,11.758-8.033,11.758-8.033A11.055,11.055,0,0,0,1179.244,386.69Z",
    transform: "translate(-1140.14 -377.229)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M480.022,203.844l20.764,19.73a4.1,4.1,0,0,1,.149,5.785l-21.1,22.205a.873.873,0,0,1-1.506-.576l-.24-9.465-17.8-16.913a4.091,4.091,0,0,1-.148-5.785l14.093-14.831A4.091,4.091,0,0,1,480.022,203.844Zm4.571,27.855a2.812,2.812,0,1,0-.875-1.968A2.812,2.812,0,0,0,484.593,231.7Zm-6.121-5.815a2.816,2.816,0,1,0-.1-3.977A2.816,2.816,0,0,0,478.472,225.883Zm-6.121-5.815a2.816,2.816,0,1,0-.1-3.982A2.816,2.816,0,0,0,472.351,220.067Z",
    transform: "translate(-466.415 -201.736)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 6.174,
    height: 18.51,
    transform: "translate(169.669 17.972)",
    fill: "#1450ff",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonSmsTextLogo);
export default __webpack_public_path__ + "static/media/falkon-sms-text-logo.becaad73748d199d7b3e68f49ab1b3db.svg";
export { ForwardRef as ReactComponent };